<template>
    <div>
      <span class="sec-description">{{ $t('diagnostic.pmix.description') }}<br><i v-if="sectionDescription">{{sectionDescription}}</i></span>
      <table v-if="pmixData" cellspacing="0" cellpadding="0">
        <thead>
          <tr>
            <th>{{ $t('diagnostic.pmix.header.pmix') }}</th>
            <th>{{ $t('general.sales') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in pmixData" v-if="isValidPmixType(item.type)">
            <td>
              <div v-if="item.type == 'A LA CARTA'">{{ $t('diagnostic.pmix.types.menu') }}</div>
              <div v-else-if="item.type == 'BEBIDAS'">{{ $t('diagnostic.pmix.types.drinks') }}</div>
              <div v-else-if="item.type == 'COMPLEMENTOS'">{{ $t('diagnostic.pmix.types.complements') }}</div>
              <div v-else-if="item.type == 'DSY & McCAFÉ'">{{ $t('diagnostic.pmix.types.mccafe') }}</div>
              <div v-else-if="item.type == 'ENSALADAS'">{{ $t('diagnostic.pmix.types.salads') }}</div>
              <div v-else-if="item.type == 'EVM'">{{ $t('diagnostic.pmix.types.evm') }}</div>
              <div v-else-if="item.type == 'HAPPY MEAL'">{{ $t('diagnostic.pmix.types.happy_meal') }}</div>
              <div v-else-if="item.type == 'POSTRES'">{{ $t('diagnostic.pmix.types.desserts') }}</div>
              <div v-else-if="item.type == 'VALUE'">{{ $t('diagnostic.pmix.types.value') }}</div>
              <div v-else>{{ item.type }}</div>

              <!-- DESCRIPTION IS SETTED ON API HARDCODED  -->
              <div class="description" v-if="item.description">{{item.description}}</div>
            </td>


            <!-- <td v-if="index == 'COMPLEMENTOS'">Complementos</td>
            <td v-else-if="index == 'ALC'">A la carta</td>
            <td v-else-if="index == 'ENSALADAS'">Ensaladas</td>
            <td v-else-if="index == 'EVM'">EVM</td>
            <td v-else-if="index == 'HAPPY MEAL'">Happy Meal</td>
            <td v-else-if="index == 'INDIVIDUAL BEBIDAS'">Bebidas</td>
            <td v-else-if="index == 'INDIVIDUAL PATATAS'">Patatas</td>
            <td v-else-if="index == 'INDIVIDUAL POSTRES_HELADOS_BIC'">Postres</td>
            <td v-else-if="index == 'LOCAL (LSM)'">Local (LSM)</td>
            <td v-else-if="index == 'MCCAFE'">McCafé</td>
            <td v-else-if="index == 'VALUE'">Value</td> -->

            <td v-if="item.value>0.5"><img src='/img/up_arrow.svg'> {{parseFloat(item.value).toFixed(2)}}%</td>
            <td v-else-if="item.value<-0.5"><img src='/img/down_arrow.svg'> {{parseFloat(item.value).toFixed(2)}}%</td>
            <td v-else-if="item.value<=0.5 && item.value>=-0.5"><img src='/img/equal.svg'> {{parseFloat(item.value).toFixed(2)}}%</td>
            <td v-else>-</td>
          </tr>          
        </tbody>
      </table>

      <div v-else class="msg-alert">{{ $t('general.empty') }}</div>
      
    </div>
</template>

<script>

export default {
  data () {
    return {
      validTypes: [
        'A LA CARTA',
        'BEBIDAS',
        'COMPLEMENTOS',
        'DSY & McCAFÉ',
        'ENSALADAS',
        'EVM',
        'HAPPY MEAL',
        'POSTRES',
        'VALUE'
      ]
    }
  },
  computed: {
    sectionDescription() {
      var section = this.$store.getters['locations/getDiagnosticDescriptions']['pmix']
      if (section && section.description) {
        return section.description;
      } else return false;
    },

    selectedLocation() {
      return this.restaurant = this.$store.getters['locations/getSelectedLocation'];
    },

    pmixData() {
      var data = this.$store.getters['locations/getPmix'];
      return (Object.keys(data).length > 0)? data : false;
    }
  },
  methods: {
    isValidPmixType(type) {
      return type !== 'VARIOS' && this.validTypes.includes(type);
    }
  },
  watch: {
    selectedLocation () {
      if (this.selectedLocation==undefined){
        this.$store.getters['locations/getSelectedLocation'];
      }
      this.$store.dispatch('locations/loadPmix', this.selectedLocation.id );
     },
  },
  created() {
    this.$store.dispatch('locations/loadPmix', this.selectedLocation.id );
  },
  beforeRouteLeave (to, from, next) {
      next();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .sec-description {
    display: block;
    color: #999;
    margin-bottom: 40px;
  }

  .msg-alert {
    background-color: #d6eaec;
    padding: 10px 20px;
    width: fit-content;
    margin: 0 auto;
    margin-bottom: 40px;
  }


  /* TABLE STYLES */
  table {
      margin: 0 auto;
      border-color: white;
      width: 60%;
      max-width: 900px;

      &.weekend {
        margin-top: 40px;
      }

      .hide {
        visibility: hidden !important;
        opacity: 0 !important;
      }

      thead {

        tr {

          &.sales {
            //background-color: black;
            //color: white;

            th {
              background-color: transparent;
            }
          }
          th {
            background-color: transparent;
            border-bottom: 1px solid var(--main_color);
            height: 50px;
            text-transform: uppercase;
            padding: 0px 10px;
            min-width: 200px;
            width: 45%;
          }
        }
      }
        
      tr {
        //background-color: rgba(255,255,255,0.5);
        height: 50px;

        &.separator {
          td {
            border-bottom: 1px solid #777;
          }
        }
      }
      
      tbody {
        //background-color: var(--main_color);
        tr:nth-child(odd) {
          //background-color: rgba(255,255,255,0.7);

          .editable {
            //background-color: rgba(255,255,255,1);
          }
        }
      }


      td {
        text-transform: uppercase;
        font-weight: bold;
        padding: 0px 5px;
        text-align: left;
        width: 10%;
        text-align: center;
        border-bottom: 1px solid #ddd;
        background-color: rgba(255,255,255,0.7);

        img {
          height: 20px;
          width: 20px;
          position: relative;
          top: 5px;
          margin-right: 5px;
        }

        .description {
          display: block;
          text-transform: none;
          font-weight: normal;
          font-size: 13px;
        }
      }

      td {
        overflow: hidden;

        &.editable {
          position: relative;
        }

        input {
          height: 40px;
          text-align: center;
          font-size: 17px;
          appearance: textfield;
          width: 100%;
          outline:0px;
        }

        &:hover {
          input {
            background-color: #eee;

          }
        }

        select {
          font-size: 15px;
          padding: 8px;
          font-weight: lighter;
        }

        .suffix {
          position: absolute;
          left: calc(50% + 8px);
          top: 15px;
          display: inline;
        }
      }

      .summary {
        td {
          background-color: #333;
          color: #fff;
        }
      }
    }

</style>
